import { useState } from 'react'

import { CardCheckbox } from '@/components/ui/CardCheckbox'
import { SubmitButton } from '@/components/ui/submit-button'
import { ChatActionWithValue } from '../../models/insuranceApplication'
import { CoverageType, EnabledCoverage } from '../../models/insuranceCoverage'

interface ChatAddCoverageProps {
  coverages: ReadonlyArray<EnabledCoverage>
  handleSubmit: (data: ChatActionWithValue) => void
  readonly?: boolean
}

export const ChatAddCoverage = ({ coverages, handleSubmit, readonly }: ChatAddCoverageProps) => {
  const [selectedCoverages, setSelectedCoverages] = useState<Array<CoverageType>>(
    coverages.filter((coverage) => coverage.required).map((coverage) => coverage.coverageType)
  )

  function onSubmit() {
    handleSubmit({
      content: {
        component: 'P',
        content: selectedCoverages
          .map((coverage) => coverages.find((c) => c.coverageType === coverage)?.label)
          .join(', '),
      },
      value: selectedCoverages,
    })
  }

  return (
    <>
      <div className="grid gap-2">
        {coverages.map((coverage) => (
          <CardCheckbox
            key={coverage.coverageType}
            isChecked={selectedCoverages.includes(coverage.coverageType)}
            className="py-4"
            contentClassName="items-start"
            onChange={(checked) => {
              if (readonly || coverage.required) return

              if (checked) {
                setSelectedCoverages([...selectedCoverages, coverage.coverageType])
              } else {
                setSelectedCoverages(selectedCoverages.filter((c) => c !== coverage.coverageType))
              }
            }}
          >
            <div>
              <div className="text-md text-ink font-semibold">{coverage.label}</div>
              <div className="text-ink-500 mt-1 text-sm">{coverage.description}</div>
            </div>
          </CardCheckbox>
        ))}
      </div>
      {!readonly && (
        <div className="mt-2 flex items-center justify-end gap-3">
          <SubmitButton onClick={onSubmit} disabled={!selectedCoverages.length} />
        </div>
      )}
    </>
  )
}
